import React from 'react'
import {connect} from 'react-redux'
import { getItem } from 'src/reducers/common/itemReducer';
import selector, { getOptionLabel } from 'src/utils/Utils';
import { REDUCER_NAME } from 'src/reducers/clients/clients';
import { Item } from 'src/components/PrimaryPanel';
import { Dl, Dd, Dt } from 'src/components/SecondaryPanel';
import { useTranslation } from 'react-i18next';
import { Section } from 'src/jbc-front/components/Form';
import styles from './TaxIncomeSectionShow.scss'
const TaxIncomeSectionShow = ({client}) => {
    const { t } = useTranslation()
    return (
        <div className={styles.container}>
            <Item>
                <Section title={t('features.Clients.components.TaxIncome.Expense_deduction')}>
                    <Dl>
                        <Dt>{t('features.Clients.components.TaxIncome.Expense_deduction_amount')} :</Dt>
                        <Dd>{`${client.employeeIncomeDeductionAmount ? Number.parseFloat(client.employeeIncomeDeductionAmount).toFixed(2) : "- "}`}</Dd>
                    </Dl>
                    {/* <Dl>
                        <Dt>{t('features.Clients.components.TaxIncome.Maximum')} :</Dt>
                        <Dd>{client.employeeIncomeReductionPercentage ? `${client.employeeIncomeReductionPercentage}%` : '-'}</Dd>
                    </Dl> */}
                </Section>
                <Section title={t('features.Clients.components.TaxIncome.Tax_deduction')}>
                    <Dl>
                        <Dt>{t('features.Clients.components.TaxIncome.Employee_tax_deduction_amount')} :</Dt>
                        <Dd>{client.employeeTaxDeductionAmount? (Number.parseFloat(client.employeeTaxDeductionAmount).toFixed(2) + ",") : "-"}&emsp;&emsp;{t('features.Clients.components.TaxIncome.Employee_tax_deduction_percentage') + ": "}{client.employeeTaxDeductionPercentage + "%" || "-"}</Dd>
                    </Dl>
                    {/* <Dl>
                        <Dt>{t('features.Clients.components.TaxIncome.Employee_tax_deduction_percentage')} :</Dt>
                        <Dd>{client.employeeTaxDeductionPercentage || "-"}</Dd>
                    </Dl> */}
                    <Dl>
                        <Dt>{t('features.Clients.components.TaxIncome.Sso_tax_reduction')} :</Dt>
                        <Dd>{client.ssoTaxDeduction === true ? t('features.Clients.components.TaxIncome.Enable') : t('features.Clients.components.TaxIncome.Disable')}</Dd>
                    </Dl>
                    {/* <Dl>
                        <Dt>{t('features.Clients.components.TaxIncome.Provident_fund_tax_reduction')} :</Dt>
                        <Dd>{`${client.providentFundTaxReduction || " "}${client.providentFundTaxReduction ? ", " : " "}${client.providentFundMaxPercentage ? t('features.Clients.components.TaxIncome.Maximum') + ": " + client.providentFundMaxPercentage + "%" : ""}`}</Dd>
                    </Dl> */}
                </Section>
            </Item>
        </div>
    )
}

export default connect(state => {
    const clientInfo = selector(getItem(REDUCER_NAME, state), 'clientTaxIncome') || {};
  
    return {
      client: clientInfo
    };
  })(TaxIncomeSectionShow);
  